import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { ROUTESLIST } from '@/static/urls.js';

export default class DummyInvoice extends Component {
  render() {
    const { item, hgg } = this.props;
    const { id, description, purchaseDate, price } = item;
    //TODO pay
    return (
      <tr className="invoice-card dashboard-table__card">
        <td className="invoice-card__number">{hgg + 1}</td>
        <td className="invoice-card__info">
          <span className="date">
            {purchaseDate && new Date(purchaseDate).toLocaleDateString('en-CA')}
          </span>
        </td>
        <td className="invoice-card__amount">$ {price}</td>
        <td className="invoice-card__amount">{id}</td>
        <td className="invoice-card__amount">paid</td>
      </tr>
    );
  }
}
//todo  <button type="button" className="btn btn-act-iconed"><i className="as-icon as-icon_arrow-download"></i></button>
/* <td className="invoice-card__pay"> 
                    { 
                        needPay &&
                        <button type="button" className="btn btn-primary" onClick={ onProcessPay }>Pay</button>
                    }
                </td> */
//<button type="button" className="btn btn-act-iconed"><i className="as-icon as-icon_arrow-download"></i></button>
